import { RevealText, FadeIn } from "../motion/Reveal";
import { SectionLabel } from "../motion/SectionLabel";
import { WHY, GEN } from "../../data/content";

const masonryCards = [
  "col-span-1 row-span-2 rounded-[1.35rem]",
  "col-span-1 row-span-1 rounded-[1.1rem]",
  "col-span-1 row-span-1 rounded-[1.1rem]",
];

export const WhyMicrodramas = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative min-h-screen flex flex-col justify-center py-28 md:py-32 px-6 md:px-10 bg-[#0a0a0a]"
    >
      <div className="max-w-[1400px] mx-auto">
        <SectionLabel>{WHY.label}</SectionLabel>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-14 items-center">
          <div className="lg:col-span-5">
            <RevealText
              as="h2"
              lines={["A new generation", "of storytelling."]}
              className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.98] tracking-tight"
            />

            <FadeIn>
              <p className="mt-12 font-display font-medium text-2xl md:text-3xl text-white leading-snug tracking-tight">
                {WHY.paragraphs[0]}
              </p>
            </FadeIn>
            <FadeIn delay={0.1}>
              <p className="mt-6 font-body text-lg text-neutral-400 leading-relaxed font-light">
                {WHY.paragraphs[1]}
              </p>
            </FadeIn>
            <FadeIn>
              <p className="mt-12 font-serif-italic text-3xl md:text-4xl text-[#ff8c00] leading-tight">
                {WHY.highlight}
              </p>
            </FadeIn>
            <FadeIn delay={0.1}>
              <p className="mt-8 font-body text-lg text-neutral-300 leading-relaxed font-light border-t border-white/10 pt-8">
                {WHY.closing}
              </p>
            </FadeIn>
          </div>

          <FadeIn
            delay={0.08}
            data-testid="why-masonry-grid"
            className="lg:col-span-7 grid grid-cols-2 grid-rows-2 gap-3 md:gap-4 h-[430px] sm:h-[520px] lg:h-[700px] w-full"
          >
            {GEN.whyMasonry.map((src, index) => (
              <div
                key={src}
                data-testid={`why-masonry-card-${index + 1}`}
                className={`${masonryCards[index]} group relative overflow-hidden border border-white/10 bg-neutral-950 shadow-[0_28px_80px_-36px_rgba(0,0,0,0.9)]`}
              >
                <img
                  src={src}
                  alt=""
                  aria-hidden
                  loading="eager"
                  data-testid={`why-masonry-image-${index + 1}`}
                  className="h-full w-full object-cover grayscale transition-[filter,transform] duration-700 ease-out group-hover:grayscale-0 group-hover:scale-105"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/10 opacity-90 transition-opacity duration-700 group-hover:opacity-35" />
              </div>
            ))}
          </FadeIn>
        </div>
      </div>
    </section>
  );
};
